import React from 'react';
import './pagefooter.css';
import { Helmet } from "react-helmet-async";

const About = () => {
  return (
    <>
      <Helmet>
        <title>
          About Best Physiotherapy Udupi & No. 1 Sports Science Center | AIKYAM
        </title>
        <meta
          name="description"
          content="Learn about AIKYAM Sports Science, Udupi's No. 1 rated sports physiotherapy and best athlete development center. Discover top-tier rehab, strength & conditioning, and our Smart Timing Gates."
        />
        <meta
          name="keywords"
          content="Best Physiotherapy Udupi, No 1 Sports Science India, Top rated sports rehab udupi, Best athlete development mangalore, best strength and conditioning udupi, Timing Gates India"
        />
        <link rel="canonical" href="https://aikyamsports.com/about" />
        <meta property="og:title" content="About Udupi's No. 1 Physiotherapy & Best Sports Science Center | AIKYAM" />
        <meta property="og:description" content="Discover AIKYAM Sports Science, the best in athlete performance, top-rated sports physiotherapy, and India's first Smart Timing Gate system." />
        <meta property="og:url" content="https://aikyamsports.com/about" />
        <meta name="twitter:title" content="About Udupi's No. 1 Physiotherapy & Best Sports Science Center" />
        <meta name="twitter:description" content="The best sports science, athlete development, and No. 1 physiotherapy clinic in Udupi." />
      </Helmet>
      
      <div className="policy-page">
        <h1>About Aikyam Sports Science</h1>

        <p className="about-lead">
          <strong>AIKYAM Sports Science</strong> is Udupi's <strong>No. 1 rated</strong> sports technology and elite human performance center. 
          Our core mission is to optimize athletic performance, recovery, strength, and psychology, establishing ourselves as the best destination for modern sports science on the coast.
        </p>

        <h2>Our Top-Rated Track Record</h2>
        <ul className="stats-list" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '16px', listStyle: 'none', padding: 0 }}>
          <li><strong>800+</strong> Patients Treated</li>
          <li><strong>98%</strong> Satisfaction Rate</li>
          <li><strong>5+ Years</strong> of Elite Experience</li>
          <li><strong>50k+</strong> Data Points Tracked</li>
        </ul>

        <h2>Udupi's Best Performance Ecosystem</h2>
        <p>
          We bridge the gap between high-performance laboratory science and daily training fields through our top-tier, two-pronged ecosystem:
        </p>

        <h3>1. Advanced Sports Technology (Made in India)</h3>
        <ul>
          <li>
            <strong>The Aikyam Timing Gate:</strong> India’s best and first device combining speed and jump assessments into a single, seamless, wireless hardware ecosystem. Operating with an ultra-precise accuracy of <strong>0.0001 seconds</strong>.
          </li>
          <li>
            <strong>The Aikyam Sports App:</strong> Available on iOS and Android, our app serves as the best centralized smart hub for coaches and individual athletes to track top-rated performance metrics.
          </li>
        </ul>

        <h3>2. Udupi's No. 1 Sports & Wellness Clinic (Ajjarkad)</h3>
        <p>
          Based out of our high-performance facility at the Center for Sports Science, Mahatma Gandhi Stadium in Udupi, we provide the best expert-led disciplines for both professionals and weekend warriors:
        </p>

        <ul className="disciplines-list">
          <li><strong>Best Sports Science Assessment:</strong> Deep biomechanical evaluation using advanced digital tracking equipment.</li>
          <li><strong>No. 1 Physiotherapy & Pain Relief:</strong> Modern clinical therapy to control acute pain patterns and accelerate soft tissue healing.</li>
          <li><strong>Top-rated Joint & Muscle Rehab:</strong> Tailored recovery pathways targeted at post-injury kinetic chains (ACL, Rotator Cuff, Hamstring, and Ankle).</li>
          <li><strong>Elite Strength & Conditioning:</strong> Science-backed physical programming built explicitly around your position and sport.</li>
          <li><strong>Clinical & Sports Nutrition:</strong> Precision metabolic fueling plans calculated to maximize training adaptations.</li>
          <li><strong>Sports Psychology:</strong> Unlocking cognitive competitive edges and managing performance anxieties.</li>
          <li><strong>Group Fitness Classes:</strong> High-energy conditioning led by Udupi's best coaching staff.</li>
        </ul>

        <h2>The Best Approach to Complete Recovery</h2>
        <p>
          Athletes face unique pressures. At Aikyam, we recognize that physical injuries are intimately linked to overall neural stress and sleep quality. 
        </p>
        <p>
          Our No. 1 rated recovery models evaluate systemic athletic loads, manage overtraining markers, and design customized return-to-sport transition frameworks so you can step back onto the field stronger and faster.
        </p>

        <div className="grant-recognition" style={{ margin: '24px 0', padding: '16px', borderLeft: '4px solid #f97316', backgroundColor: 'rgba(249, 115, 22, 0.05)' }}>
          <p style={{ margin: 0, fontWeight: '500' }}>
            🇮🇳 <strong>Government Recognition & Innovation:</strong> We are proud recipients of the prestigious <strong>NIDHI-EIR</strong> and <strong>NIDHI-PRAYAS</strong> grants, awarded by the Department of Science and Technology, Government of India, recognizing us as the best in engineering excellence in sports tech.
          </p>
        </div>
      </div>
    </>
  );
};

export default About;